import React, { Component } from 'react'
import { ComponentBox, DataView, DataWrapperClass, DateView, UserName, ContentData, BoxData, IconData, TagLine, DescData, DataViewList } from '../styles/main'

export class ContactInfoActivityTimelineTheme extends Component {

  constructor(props) {
    super(props);
    this.open = this.open.bind(this);
    this.renderActivity = this.renderActivity.bind(this);
    this.renderActivityList = this.renderActivityList.bind(this);
    this.state = {
      isActive: false,
      list: this.processData(props.comments)
    };

  }


  componentWillReceiveProps(nextProps, prevState) {
    if (nextProps.comments) {
      let currentComments = JSON.stringify(nextProps.comments);
      let prevComments = JSON.stringify(prevState.comments);
      if (currentComments !== prevComments) {
        let comments = nextProps.comments;
        this.setState({
          list: this.processData(comments)
        })
      }
    }
  }
  open() {
    if (this.state.isActive) {
      this.setState({ isActive: false });
    } else {
      this.setState({ isActive: true });
    }

  }
  processData(data) {
    let dateWise = {};
    data.map((el) => {
      if (el && el.Date) {
        if (!dateWise[el.Date]) {
          dateWise[el.Date] = [];
        }
        dateWise[el.Date].push(el)
      }
    })
    // console.log("processData",data, dateWise );
    return dateWise;
  }
  renderTag(tags) {
    if (tags && tags[0] && tags[0][0] && tags[0][0].label) {
      return tags[0][0].label;
    } else {
      return "";
    }
  }
  renderActivity(data) {
    return (
      <DataView>
        <span className='time col-md-2'>{data.time}</span>
        <ContentData className='col-md-10'>
          <BoxData>
            <span>
              <IconData>
                {data.CallType && data.CallType == "inboundCall" ? <img src="/images/CallDemo.png" /> : <img src="/images/CallDemo.png" />}
              </IconData>
            </span>
            <span>
              <TagLine>
                <h6>{data.agentName}</h6>
                <span>{this.renderTag(data.tags)}</span>
              </TagLine>
              <DescData>
                <div>{data.comment}</div>
                {/* <div>Contrary to popular belief, Lorem Ipsum is not simply random text...Contrary to popular belief, Lorem Ipsum is not simply random text...
                                {this.state.isActive && 'Contrary to popular belief, Lorem Ipsum is not simply random text...'}
                                <span onClick={() => this.open()}>{!this.state.isActive ? 'see more' : 'see less'}</span>
                            </div> */}
              </DescData>
            </span>
          </BoxData>
        </ContentData>
      </DataView>
    )
  }
  renderActivityList(data) {
    console.log("renderActivityList", data);
    return (
      data.map((logs) => this.renderActivity(logs))
    )
  }
  render() {
    let _this = this;
    return (
      <DataWrapperClass>
        <UserName style={{ padding: '20px' }}>
          Activity Timeline
        </UserName>
        <ComponentBox>
          {
            this.state.list && Object.keys(this.state.list).map(function (key) {
              return (
                <span>
                  <DateView>
                    <span className='date'>{key}</span>
                    <hr />
                  </DateView>
                  {_this.renderActivityList(_this.state.list[key])}
                </span>

              )
            })
          }
        </ComponentBox>
      </DataWrapperClass>
    )
  }
}

export default ContactInfoActivityTimelineTheme


// WEBPACK FOOTER //
// ./src/modules/theme/theme1/common/components/ContactInfoActivityTimelineTheme.js